import { Create, useForm } from '@refinedev/antd';
import { Form, Input } from 'antd';
import { IEcommerceDivision } from 'interfaces/ecommerce_divisions';
import { useNavigation } from '@refinedev/core';

export const EcommerceDivisionCreate = () => {
  const navigate = useNavigation();
  const { formProps, saveButtonProps } = useForm<IEcommerceDivision>({
    resource: 'ecommerce/divisions',
    redirect: false,
    onMutationSuccess: () => {
      navigate.push('/ecommerce/ecommerce_divisions');
    }
  });

  return (
    <Create saveButtonProps={saveButtonProps} title="Criar divisão">
      <Form
        {...formProps}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 14 }}
        layout="horizontal"
        style={{ maxWidth: 600 }}
      >
        <Form.Item
          label="Código"
          name="code"
          rules={[
            {
              required: true
            }
          ]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Descrição"
          name="description"
          rules={[
            {
              required: true
            }
          ]}
        >
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Create>
  );
};
